var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifyLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 51,
    viewBox: "0 0 198 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.582 16.0915L153.092 12.8115C151.532 12.6745 149.94 13.8665 149.548 15.4675L144.488 36.1555C144.097 37.7515 145.052 39.1655 146.612 39.3015L184.102 42.5815C185.663 42.7185 187.254 41.5275 187.645 39.9315L192.705 19.2435C193.097 17.6415 192.142 16.2275 190.582 16.0915ZM151.165 13.8595C151.691 13.4745 152.332 13.2635 152.967 13.3185L190.458 16.5985C191.021 16.6485 191.489 16.8985 191.81 17.2755L191.839 17.2615L191.871 17.3505C192.241 17.8315 192.387 18.4945 192.215 19.2005L187.154 39.8885C186.831 41.2075 185.515 42.1925 184.225 42.0795L146.735 38.7995C145.445 38.6875 144.655 37.5175 144.978 36.1985L150.038 15.5105C150.158 15.0235 150.412 14.5835 150.75 14.2255L150.585 14.0835L150.954 13.6785L151.165 13.8595Z",
    fill: "#B2D235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.954 13.6783L150.585 14.0833L150.75 14.2263L166.367 27.6623C166.925 28.1433 167.628 28.4233 168.383 28.4903C169.15 28.5573 169.975 28.4043 170.748 28.0283L192 17.7073L191.871 17.3503L191.839 17.2613L191.81 17.2753L170.587 27.5823C169.907 27.9113 169.186 28.0423 168.512 27.9833C167.845 27.9253 167.224 27.6803 166.731 27.2563L151.165 13.8593L150.954 13.6783Z",
    fill: "#B2D235"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_327_12392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 184,
    y: 8,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.489 8.04297H197.875V21.371H184.489V8.04297Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_327_12392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.803 8.06729C189.22 7.75329 185.588 10.4713 184.691 14.1363C183.794 17.8073 185.972 21.0323 189.555 21.3463C193.143 21.6603 196.775 18.9433 197.673 15.2723C198.57 11.6073 196.392 8.38129 192.803 8.06729Z",
    fill: "#FC2431"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.987 12.7117L190.866 12.914L189.382 16.6347L191.048 17.0192L193.056 11.9837L190.512 11.396L189.987 12.7117Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.2 5.24606L46.8062 0.0187465C44.1252 -0.221047 41.3962 1.86766 40.7248 4.67667L38.1506 15.447C37.4792 18.256 39.1161 20.7354 41.7962 20.9752L90.6225 25.3461L93.5524 29.6013C93.7152 29.8337 93.9577 29.9707 94.2382 29.9957C94.3848 30.0096 94.5404 29.9893 94.6988 29.9402C95.1593 29.7939 95.5168 29.4069 95.6299 28.9338L96.3646 25.8609L100.19 26.2025C102.874 26.4433 105.603 24.3546 106.274 21.5455L108.849 10.7752C109.521 7.96619 107.884 5.48678 105.2 5.24606ZM41.893 20.5688C39.4264 20.3475 37.9217 18.0672 38.5397 15.4813L41.1139 4.71185C41.7319 2.12597 44.2419 0.204841 46.7085 0.425192L105.103 5.65343C107.573 5.87379 109.078 8.15506 108.46 10.74L105.886 21.5104C105.268 24.0953 102.758 26.0174 100.288 25.7961L96.0696 25.4184L95.2381 28.8986C95.1503 29.2652 94.8707 29.4763 94.6373 29.5522C94.545 29.581 94.44 29.5958 94.3341 29.5865C94.1713 29.5717 94.0084 29.4995 93.8926 29.3319L90.8768 24.9536L41.893 20.5688Z",
    fill: "#B2D235"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_327_12392",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 25,
    width: 72,
    height: 26
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 25.1105H71.1162V51H0V25.1105Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_327_12392)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4394 30.3713L8.62449 25.1286C6.02428 24.8974 3.39036 26.905 2.74054 29.6117L0.145801 40.4166C-0.504022 43.1243 1.07542 45.507 3.67654 45.7392L7.72767 46.1004L6.93932 49.3847C6.80079 49.9614 7.1617 50.3857 7.63471 50.4275C7.85527 50.447 8.10043 50.3839 8.3301 50.2149L13.237 46.5916L62.4914 50.9819C65.0925 51.214 67.7265 49.2055 68.3763 46.4987L70.9701 35.6939C71.6199 32.9862 70.0405 30.6035 67.4394 30.3713Z",
    fill: "#B2D235"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyLeft);
export default __webpack_public_path__ + "static/media/verify-left.b03e576a.svg";
export { ForwardRef as ReactComponent };